export default {
	service: [
		"Usługa",
		"Wydarzenie",
		"Wypłata",
		"Depozyt",
		"Regulamin",
		"Certyfikat",
		"FAQs",
		"Przewodnik użytkownika",
		"VIP"
	],
	sign: {
		title: "Zalogowany przez {0} dzień",
		SignIn: "Zaloguj się"
	},
	hotMusicAlbum: "Gorący Album Muzyczny",
	hotMusic: "Gorące Listy Przebojów",
	popular: "Nowe odtwarzanie",
	rankings: "Popularne filmy",
	top: "TOP{0}",
	OnchainServices: "Usługi Onchain",
	Real: {
		title: "W czasie rzeczywistym",
		list: [
			"Łączna liczba użytkowników online",
			"Średni wolumen optymalizacji na użytkownika",
			"Mapa cieplna potrzeb optymalizacji",
			"Ilość optymalizacji promocji platformy"
		]
	},
	work: {
		title: "Nagroda za złożenie zamówienia",
		SignIn: "Zdobądź"
	},
	Profit: {
		Profit: "Zysk",
		tabs: ["Zysk", "Bonus", "Konto"],
		TotalBalance: "Całkowite saldo",
		TotalLuckyBonus: "Całkowity Szczęśliwy Bonus",
		todayEarnings: "Dzisiejsze Zarobki",
		availableBalance: "Dostępne saldo",
		title: ["Dzisiejsze Zarobki", "Całkowite Zarobki", "Konto"],
		list: ["Zarobki z Zamówień", "Zarobki Zespołu", "Całkowite Zarobki"],
		order: {
			title: "Zysk z Zamówienia",
			commission: "Prowizja z Zamówienia"
		},
		Analysis: {
			title: "Analiza Zysków",
			tips: "Dokonałeś {0} transakcji",
			tabs: ["Dzisiejszy Zysk", "Całkowity Zysk"],
			totalTitle: ["Zysk z Zamówienia", "Zysk z Zameldowania", "Zysk Zespołu", "Zysk z Bonusu"]
		}
	},
	CustomerService: {
		title: "Centrum Obsługi Klienta",
		consultation: "Konsultacja Obsługi Klienta",
		btn: "Skontaktuj się z nami",
		noticeTitle: "Powiadomienie Systemowe"
	},
	addWallet: "Dodaj portfel",
	taskProgress: "Postęp codziennych zadań",
	currentProgress: "Aktualny postęp zadania",
	awardsBulletin: `{0} użytkownik wygrywa {1} {2} nagrodę w zadaniu.`,
	vip: {
		title: "@:vip.title",
		more: "Zobacz więcej"
	},
	stats: {
		title: "Źródła danych - Panel i API",
		subTitle: "Statystyki artystów",
		list: ["Metryki", "Artiści z aktywnymi mediami społecznościowymi", "Aktualizowane codziennie"]
	}
};
